<template>
  <div class="mb-6">
    <h1 class="display-1 mb-3"><ressource :code="code" /></h1>
    <v-divider class="my-3"></v-divider>
    <ressource :code="'sous-' + code" hide-if-empty />
  </div>
</template>

<script>
export default {
  props: {
    code: { type: String }
  }
}
</script>

<style>
</style>